
document.addEventListener("DOMContentLoaded", function(event) { 
    
    const formElement = document.querySelector('[data-product-form]');
    const productHandle = formElement.dataset.productHandle;

    const selectors = {
        submitButton: "[data-submit-button]",
        submitButtonText: "[data-add-to-cart-text]",
    };
  
    axios.get(`/products/${productHandle}.js`)
      .then(response => {
        //   console.log(response);
        return response.data;
      })
      .then(productJSON => {
        const productForm = new Shopify.ProductForm(formElement, productJSON, {
          onOptionChange,
          onSubmit: null
        });
      });
  
     
    // This function is called whenever the user changes the value of an option input
    function onOptionChange(event) {
      const variant = event.dataset.variant;
      renderSubmitButton(variant);
      updateUrlVariant(variant);
      renderImages(variant);
      renderPrice(variant);
    }
  
    function renderSubmitButton(variant){
        const submitButton = document.querySelector(selectors.submitButton);
        const submitButtonText = document.querySelector(selectors.submitButtonText);
        if(!variant){
            submitButton.disabled = true;
            submitButtonText.innerText = Shopify.theme.strings.unavailable;
        } else if (variant.available) {
            submitButton.disabled = false;
            $(submitButtonText).html('<i class="fas fa-plus fa-fw mr-2"></i> '+ Shopify.theme.strings.addToCart);
        } else {
            submitButton.disabled = true;
            submitButtonText.innerText = Shopify.theme.strings.soldOut;
        }
    }
  
    function updateUrlVariant(variant){
        if(!variant) return;
        const url = this.Shopify.ProductForm.getUrlWithVariant(window.location.href, variant.id);
        window.history.replaceState({ path: url }, '', url);
    }
  
    function renderImages(variant) {
        
        if (!variant || !variant.featured_media || variant.featured_media === null) {
            return;
        }
  
        var slickIndex = $(
            '[data-image-id="' + variant.featured_media.id + '"]'
        )
            .parent()
            .parent(':not(.slick-cloned)')
            .data("slick-index");
            
        $(".slick-product-img-highlight").slick("slickGoTo", slickIndex);
    }

    function renderPrice(variant){

        console.log(variant);
        const PriceText = document.querySelector('[data-product-price]');
        const ComparePriceText = document.querySelector('[data-product-compare-price]');
        const format = Shopify.theme.strings.moneyFormat;

        if(variant){
            PriceText.innerHTML = Shopify.formatMoney(variant.price, format);
        }

        if(variant.compare_at_price){
            ComparePriceText.innerHTML = Shopify.formatMoney(variant.compare_at_price, format);
            $('[data-product-compare-price]').removeClass('d-none');
        } else {
            $('[data-product-compare-price]').addClass('d-none');
        }
    }

    var toggleButtonGroup = $('.btn-group-toggle');
	var getButtonIndex = toggleButtonGroup.find('input[type="radio"]:checked').parent().index();


	toggleButtonGroup.find('input[type="radio"]').click(function() {
		$(this).parent().parent().find('label').removeClass('active');
		// console.log($(this).parent().index());
		$(this).closest('label').addClass('active');
		// $('.slick-product-big').slick('slickGoTo', $(this).parent().index());
		// $('.slick-product-nav').slick('slickGoTo', $(this).parent().index());
    });
    
});
  